export default {
    // 设置带过期时间的存储
    setWithExpiry(key, value, expiryInMinutes) {
        const item = {
            value: value,
            expiry: Date.now() + expiryInMinutes * 60 * 1000 // 当前时间 + 过期时间（毫秒）
        };
        this.getStorage().setItem(key, JSON.stringify(item));
    },

    // 获取存储的值（检查是否过期）
    getWithExpiry(key) {
        let itemStr = this.getStorage().getItem(key);

        if (!itemStr) return null;
        const item = JSON.parse(itemStr);

        const remember = localStorage.getItem('WEBSITE_LOGIN_REMEMBER');
        const loginState = localStorage.getItem('WEBSITE_LOGIN_STATE');
        if (loginState == 1 && remember == 'true') {
            if (Date.now() > item.expiry) {
                this.getStorage().removeItem(key);
                return null;
            }
        }
        return item.value;
    },

    // 清理所有过期项
    cleanupExpiredItems() {
        Object.keys(this.getStorage()).forEach(key => {
            const itemStr = this.getStorage().getItem(key);
            try {
                const item = JSON.parse(itemStr);
                if (item && item.expiry && Date.now() > item.expiry) {
                    this.getStorage().removeItem(key);
                }
            } catch (e) {
                // 不是我们存储的格式，忽略
            }
        });
    },

    getStorage() {
        const remember = localStorage.getItem('WEBSITE_LOGIN_REMEMBER');
        const loginState = localStorage.getItem('WEBSITE_LOGIN_STATE');

        if (loginState != 1 || remember == 'true') {
            return localStorage
        } else {
            return sessionStorage
        }
    },

};